export const APP_STORE_URL = 'https://apps.apple.com/app/gamma-prime/id6781283398';
export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.gammaprime.app';

export type MobileStore = 'app-store' | 'google-play';

export const STORE_URLS: Record<MobileStore, string> = {
  'app-store': APP_STORE_URL,
  'google-play': GOOGLE_PLAY_URL,
};

export const detectMobileStore = (): MobileStore | null => {
  const { userAgent, maxTouchPoints } = navigator;
  if (/android/i.test(userAgent)) return 'google-play';
  // iPadOS reports a desktop Mac user agent; only touch support tells it apart.
  if (/iphone|ipad|ipod/i.test(userAgent) || (/macintosh/i.test(userAgent) && maxTouchPoints > 1)) {
    return 'app-store';
  }
  return null;
};
